var _classCallCheck = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/inherits");

var Transaction = require('../../transaction');

var debug = require('debug')('knex:tx');

var _require = require('lodash'),
    isUndefined = _require.isUndefined;

var Transaction_MySQL2 =
/*#__PURE__*/
function (_Transaction) {
  "use strict";

  _inherits(Transaction_MySQL2, _Transaction);

  function Transaction_MySQL2() {
    _classCallCheck(this, Transaction_MySQL2);

    return _possibleConstructorReturn(this, _getPrototypeOf(Transaction_MySQL2).apply(this, arguments));
  }

  return Transaction_MySQL2;
}(Transaction);

Object.assign(Transaction_MySQL2.prototype, {
  query: function query(conn, sql, status, value) {
    var _this = this;

    var t = this;
    var q = this.trxClient.query(conn, sql).catch(function (err) {
      return err.code === 'ER_SP_DOES_NOT_EXIST';
    }, function () {
      _this.trxClient.logger.warn('Transaction was implicitly committed, do not mix transactions and ' + 'DDL with MySQL (#805)');
    }).catch(function (err) {
      status = 2;
      value = err;
      t._completed = true;
      debug('%s error running transaction query', t.txid);
    }).then(function (res) {
      if (status === 1) t._resolver(value);

      if (status === 2) {
        if (isUndefined(value)) {
          if (t.doNotRejectOnRollback && /^ROLLBACK\b/i.test(sql)) {
            t._resolver();

            return;
          }

          value = new Error("Transaction rejected with non-error: ".concat(value));
        }

        t._rejecter(value);

        return res;
      }
    });

    if (status === 1 || status === 2) {
      t._completed = true;
    }

    return q;
  }
});
module.exports = Transaction_MySQL2;